<script setup lang="ts">
import { socketService } from "@/utils/socket";
import { computed } from "vue";

// Environment variables (cannot use import.meta.env directly in template)
const envMode = import.meta.env.MODE;
const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:4000";

// WebSocket status
const isWsConnected = socketService.getConnectionState();
const wsStatus = computed(() =>
  isWsConnected.value ? "Connected" : "Disconnected",
);
</script>

<template>
  <div class="p-4 border-t border-gray-200">
    <div class="px-3 py-2 bg-gray-50 rounded-lg">
      <p class="text-xs text-gray-600 flex items-center gap-2">
        <span
          :class="[
            'inline-block w-2 h-2 rounded-full',
            isWsConnected
              ? 'bg-green-500 animate-pulse'
              : 'bg-red-500',
          ]"
        ></span>
        <strong>WebSocket:</strong> {{ wsStatus }}
      </p>
      <p class="text-xs text-gray-600 mt-1 flex items-center gap-2">
        <span class="inline-block w-2 h-2 rounded-full bg-blue-500"></span>
        <strong>Environment:</strong> {{ envMode }}
      </p>
      <p class="text-xs text-gray-600 mt-1 flex items-center gap-2">
        <span class="inline-block w-2 h-2 rounded-full bg-purple-500"></span>
        <strong>API:</strong> {{ apiUrl }}
      </p>
    </div>
  </div>
</template>
